export const visit = (vm, at) => {
at({ "fr": { "conversations-visitor-ui": { "pageTitleNotifications": { "newMessage": "Nouveau message" } } } });
};